import { cn } from '@/lib/utils/tw-merge';

export const modalStyles = {
    base: 'ui-modal fixed inset-0 z-300 w-screen overflow-hidden',
    container: 'flex h-full items-center justify-center p-4',
    panel: cn(
        'ui-modal-panel',

        'relative flex flex-col bg-body text-body p-10 w-full md:p-18',
        'max-h-[min(900px,100%)]', // cap height; the body scrolls inside instead of the overlay
        'md:rounded-3xl md:overflow-hidden', // rounded on md+; clip full-bleed section backgrounds to the radius
        'pointer-events-auto',
        'duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0',
    ),
    body: 'min-h-0 flex-1 overflow-y-auto scrollbar-hidden', // scroll container; padding stays on the panel so !p-0 keeps full-bleed
    backdrop: 'fixed inset-0 bg-black/70 duration-300 ease-out data-closed:opacity-0',

    closeButton: cn(
        'absolute',
        'size-11 rounded-full',
        'flex items-center justify-center',
        'cursor-pointer',
        'z-50', // ensure the close button stays clickable above modal content
    ),
    closeButtonPositions: {
        'top-right': 'top-3 right-3',
        'top-left': 'top-6 left-6',
    },

    sizes: {
        md: 'max-w-180',
        lg: 'max-w-248',
        xl: 'max-w-300',
        xxl: 'max-w-350',
        full: '!size-full',
    },
} as const;
